<template>
	<span class="aup-base-eye-toggle" @click="local_value = !local_value">
		<!-- SVG -->
		<IconEyeVisible v-if="local_value"/>
		<IconEyeHidden v-else/>
	</span>
</template>
<script>
export default {
	name: "BaseEyeToggle",
	props: {
		value: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		local_value(val) {
			this.$emit('input', val);
		}
	},
	data() {
		return {
			local_value: this.value
		};
	}
};
</script>
<style lang="scss">
	.aup-base-eye-toggle {
		svg {
			height: 1em;
		}
	}
</style>